import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Love.scss";
import InnerNav from "../../../../../components/InnerNav/InnerNav";
import Footer from "../../../../../components/Footer/Footer";
import { useFormData } from "../../ContextData/ContextData"; // assuming birth details are in context

const Love = () => {
  const { userData } = useFormData(); // {year, month, day, hour, minute}
  const [prediction, setPrediction] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!userData) return;

    const fetchPrediction = async () => {
      try {
        const response = await axios.get(
          "https://core-c343.onrender.com/api/predict-love",
          {
            params: {
              year: userData.year,
              month: userData.month,
              day: userData.day,
              hour: userData.hour,
              minute: userData.minute,
            },
          }
        );
        setPrediction(response.data);
      } catch (err) {
        setError("Failed to load love, health, and hobbies prediction.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchPrediction();
  }, [userData]);

  if (loading) {
    return (
      <div className="lhh-container">
        <InnerNav />
        <p>Loading predictions...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="lhh-container">
        <InnerNav />
        <p className="error">{error}</p>
      </div>
    );
  }

  return (
    <div className="lhh-container">
      <InnerNav />
      <h2>{prediction?.aspect}</h2>
      <div className="lhh-cards">
        {prediction?.sections &&
          Object.entries(prediction.sections).map(([subTitle, content]) => (
            <div key={subTitle} className="lhh-card">
              <h3>{subTitle}</h3>
              <p>{content}</p>
            </div>
          ))}
      </div>
      <Footer />
    </div>
  );
};

export default Love;
